/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityInfraDashboardSummaryRequest extends models.SecurityInfraDashboardBaseFilters {
    getFixupPrototypeFunction() { return SecurityInfraDashboardSummaryRequest.fixupPrototype; }

    static newInstance(model: Partial<SecurityInfraDashboardSummaryRequest>): SecurityInfraDashboardSummaryRequest {
        let obj = Object.assign(new SecurityInfraDashboardSummaryRequest(), model);
        SecurityInfraDashboardSummaryRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityInfraDashboardSummaryRequest>): SecurityInfraDashboardSummaryRequest {
        if (!model) return null;
        return SecurityInfraDashboardSummaryRequest.newInstance(<SecurityInfraDashboardSummaryRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityInfraDashboardSummaryRequest) {
        if (!obj) return;

        models.SecurityInfraDashboardSummaryRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityInfraDashboardSummaryRequest): boolean {
        if (models.SecurityInfraDashboardBaseFilters.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, SecurityInfraDashboardSummaryRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    group_by: Array<models.SecurityInfraDashboardSummaryGroupBy>;

}
